export const POLLING_TIME = 2 * 1000 * 60